import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Action } from '../../models/Action';
import { environment } from '../../../environments/environment';
import { FirebaseService } from '../auth/firebase.service';

@Injectable({
  providedIn: 'root'
})
export class ActionService {

  constructor(private http: HttpClient,
              private firebaseService: FirebaseService){}

  /**
   * Create a new action
   */
  createAction(action: Partial<Action>){
    return this.http.post<Action>(`${environment.URL_API}/api/actions`, action, {headers: this.firebaseService.authHeader})
  }

  /**
   * Get Action by ID
   */
  getActionById(action_id: string){
    return this.http.get<Action>(`${environment.URL_API}/api/actions/${action_id}`, {headers: this.firebaseService.authHeader})
  }

  /**
   * Update a new action
   */
  updateAction(action: Partial<Action>){
    return this.http.put<Action>(`${environment.URL_API}/api/actions/${action.id}`, action, {headers: this.firebaseService.authHeader})
  }
}
